import { useQuery } from '@tanstack/react-query';
import { chatSearchApi } from './chat-search-api';

export const CHAT_SEARCH_QUERY_KEY = 'chat-search';

export const useChatSearchQuery = (query, options = {}) => {
  return useQuery({
    queryKey: [CHAT_SEARCH_QUERY_KEY, query],
    queryFn: () => chatSearchApi.search(query),
    enabled: !!query.trim(),
    ...options,
  });
};
